<!-- Screenname: Stock Reason Master Creation
Developer Name:Bharanidharan.
Created date on:1/02/2023
Last Working date on:23/03/2023
Comments and Suggestions:
TS File:GenericMasterService -->

<template>
  <Dialog
    v-model:visible="showDialog"
    :modal="true"
    :header="
      model
        ? $t('createSr.EditcreateStockreason')
        : $t('createSr.createStockreason')
    "
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '40vw' }"
    @after-hide="IsClear"
  >
    <b-form @submit.prevent="IsSubmit">
      <b-row>
        <b-col sm="6">
          <div class="field">
            <TextInput
              v-model="stockreasonform.Code"
              type="text"
              placeholder=" "
              :requiredIcon="true"
              clearable
              name="Code"
              id="Code"
              :label="$t('createSr.rcode')"
              :rules="{ required: true }"
              disabled
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="8">
          <div class="field">
            <TextInput
              v-model="stockreasonform.ReasonName"
              type="text"
              placeholder=" "
              :requiredIcon="true"
              clearable
              name="Reason Name"
              id="Reason Name"
              :label="$t('createSr.rname')"
              :rules="{ required: true }"
              :autofocus="true"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="8">
          <div class="field">
            <TextInput
              v-model="stockreasonform.Remarks"
              type="text"
              placeholder=" "
              :requiredIcon="true"
              clearable
              name="Remarks"
              id="Remarks"
              :label="$t('createSr.remark')"
              :rules="{ required: true, alphabet: true }"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <Footer
            @cancel="(showDialog = false), IsClear()"
            :cancelhide="false"
            :label="label"
            :loading="Saveloading"
          />
        </b-col>
      </b-row>
    </b-form>
  </Dialog>
  <createdsuccessfully :visible="successpop" @ok="closetrigger()" />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <AlreadyExist :visible="alreadyexistpop" @ok="alreadyclosetrigger()" />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";

import Footer from "../../../../../../components/FormComponents/Footer.vue";
import StockReasonservice from "../../../../Service/StockReasonService";
import TextInput from "../../../../../../components/FormComponents/TextInput.vue";
import common from "../../../../Service/CommonService";
import createdsuccessfully from "../../../../../../components/FormComponents/createdsuccessfully.vue";
import EditConfirmation from "../../../../../../components/FormComponents/EditConfirmation.vue";
import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import UpdatedSuccessfully from "../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import AlreadyExist from "../../../../../../components/FormComponents/AlreadyExist.vue";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import moment from "moment";
export default defineComponent({
  props: {
    trigger: {
      readonly: false,
      type: Boolean,
      default: ref(false),
    },
    selectedItem: {
      type: Object,
      Default: () => {},
    },
    showButton: {
      type: Boolean,
      Required: true,
    },
    OperationID: {
      type: Object,
      default: {},
    },
    EntityId: {
      type: Number,
      default: 0,
    },
  },
  components: {
    Footer,
    TextInput,
    createdsuccessfully,
    EditConfirmation,
    UpdatedSuccessfully,
    AlreadyExist,
    Loader,
  },
  setup(props, { emit }) {
    //Session Hospital&Branch ID
    let session: any = localStorage.getItem("UsersData");

    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    // let Entitydata = ref();
    // Entitydata.value = localStorage.getItem("EntityData");
    // Entitydata.value = JSON.parse(Entitydata.value);
    let Entitydata = ref({
      EntityId: 0,
    });
    Entitydata.value.EntityId = props.EntityId;
    const showDialog = ref(false);
    const model: any = ref(props.selectedItem);
    const successpop = ref(false);
    const Editmodel = ref(false);
    const { handleSubmit, errors, resetForm, resetField, validate } = useForm();
    const updatepop = ref(false);
    const alreadyexistpop = ref(false);
    const { t } = useI18n();
    const label = ref(t("btn.save"));
    let Saveloading = ref(false);

    if (model.value != null) {
      IsEdit();
    } else {
      IsCreate();
    }
    const stockreasonform = ref({
      Id: 0,
      Code: "",
      ReasonName: "",
      Remarks: "",
      CreatedAt: "",
      CreatedBy: 0,
      ModifiedAt: "",
      ModifiedBy: 0,
      HospitalId: 0,
      BranchId: 0,
      EntityId: 0,
      EntityOperationId: 0,
    });
    const copydataModel = JSON.parse(JSON.stringify(stockreasonform.value));

    //Edit-Popup
    async function IsConfirmEdit() {
      Editmodel.value = true;
    }

    //Get Value from Table and show in Popup
    async function IsEdit() {
      try {
        debugger;
        emit("loadershow");
        label.value = t("btn.update");
        let Id = model.value.Id;
        let response = await StockReasonservice.getdata(Id);
        let datas = response["result"];
        Object.keys(stockreasonform.value).forEach((key) => {
          if (datas[key]) stockreasonform.value[key] = datas[key];
        });
        showDialog.value = true;
        Editmodel.value = false;
        emit("loaderhide");
      } catch (error) {
        emit("loaderhide");
        console.log(error);
      }
    }

    //Create-Popup
    function IsCreate() {
      showDialog.value = true;
      GetCode();
    }

    //Save Fn
    const IsSubmit = async () => {
      emit("loadershow");
      Saveloading.value = true;

      // Run validation on all fields
      const results = await validate();

      if (!results.valid) {
        const form = document.querySelector("form");
        const allFormFields: any = form?.querySelectorAll("[id]");
        console.log("All form fields:", allFormFields);

        const errorFields = Object.keys(results.errors);
        const firstErrorField = errorFields[0];
        console.log("First error:", firstErrorField);

        for (const field of allFormFields) {
          console.log("Checking field:", field.id);
          if (field.id === firstErrorField) {
            const component = field.closest(".field");

            if (!component) continue;

            if (component.querySelector(".p-calendar")) {
              const calendar = component.querySelector(".p-calendar input");
              if (calendar) {
                calendar.focus();
                calendar.click();
              }
            } else if (component.querySelector(".p-dropdown")) {
              const dropdown = component.querySelector(".p-dropdown");
              if (dropdown) {
                dropdown.click();
                dropdown.querySelector(".p-dropdown-trigger")?.click();
              }
            } else if (component.querySelector(".p-multiselect")) {
              const multiselect = component.querySelector(".p-multiselect");
              if (multiselect) {
                multiselect.click();
                multiselect.querySelector(".p-multiselect-trigger")?.click();
              }
            } else if (component.querySelector(".p-autocomplete")) {
              const autocomplete = component.querySelector(
                ".p-autocomplete input"
              );
              if (autocomplete) {
                autocomplete.focus();
                autocomplete.click();
              }
            } else {
              const input = component.querySelector("input, textarea");
              if (input) {
                input.focus();
                if (
                  input.type === "text" ||
                  input.type === "email" ||
                  input.tagName.toLowerCase() === "textarea"
                ) {
                  input.select();
                }
              }
            }

            component.scrollIntoView({ behavior: "smooth", block: "center" });
            break;
          }
        }

        Saveloading.value = false;
        return;
      }

      try {
        let result: any;
        let msg = "";
        stockreasonform.value.CreatedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        stockreasonform.value.ModifiedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        stockreasonform.value.BranchId = BranchId;
        stockreasonform.value.HospitalId = HospitalId;
        stockreasonform.value.ModifiedBy = UserId;
        stockreasonform.value.CreatedBy = UserId;
        stockreasonform.value.EntityId = Number(Entitydata.value.EntityId);
        if (stockreasonform.value.Id != 0) {
          //IsCreate Function for Edit(Update) Method
          stockreasonform.value.EntityOperationId = props.OperationID.UpdateId;
          const result = await StockReasonservice.updatedata(
            stockreasonform.value
          );
          msg = result["ErrorInfo"].ErrorCode;
          emit("loaderhide");
          if (result["result"] == "Already" && msg == null) {
            Saveloading.value = false;
            alreadyexistpop.value = true;
          } else if (msg == null) {
            Saveloading.value = false;
            updatepop.value = true;
          } else {
            Saveloading.value = false;
            alert("something went wrong");
          }
        } else {
          //IsCreate Function for Create Method
          stockreasonform.value.EntityOperationId = props.OperationID.CreateId;
          const result = await StockReasonservice.createdata(
            stockreasonform.value
          );
          msg = result["ErrorInfo"].ErrorCode;
          emit("loaderhide");
          if (result["result"] == "Already" && msg == null) {
            Saveloading.value = false;
            alreadyexistpop.value = true;
          } else if (msg == null) {
            Saveloading.value = false;
            successpop.value = true;
          } else {
            Saveloading.value = false;
            alert("something went wrong");
          }
        }
      } catch (error) {
        Saveloading.value = false;
        emit("loaderhide");
        console.log(error);
      }
    };
    onMounted(() => {
      debugger;
      document.addEventListener("keydown", onKeyUp);
    });

    let isSubmitCalled = false;
    function onKeyUp(event: KeyboardEvent) {
      debugger;

      if (event.altKey && event.key == "s") {
        if (!isSubmitCalled) {
          isSubmitCalled = true;
          IsSubmit();
        }
      } else if (
        (event.altKey && event.key == "c") ||
        (event.key == "Escape" &&
          successpop.value == false &&
          updatepop.value == false &&
          alreadyexistpop.value == false)
      ) {
        IsClear();
      } else if (
        event.key == "Escape" &&
        (successpop.value == true || updatepop.value == true)
      ) {
        closetrigger();
      } else if (event.key == "Escape" && alreadyexistpop.value == true) {
        alreadyclosetrigger();
      }
    }
    //ISclear Values while clicking Add New Button
    const IsClear = () => {
      Object.assign(stockreasonform.value, copydataModel);
      emit("update:selectedItem", undefined);
      emit("close");
    };

    // Popup-Close
    function closetrigger() {
      successpop.value = false;
      updatepop.value = false;
      emit("load");
      IsClear();
    }
    function alreadyclosetrigger() {
      debugger;
      alreadyexistpop.value = false;
      stockreasonform.value.ReasonName = "";
      //showDialog.value = true
    }

    //Auto Generate Code for StockReason Code
    async function GetCode() {
      debugger;
      let data = {
        // FormId: 22,
        EntityId: Entitydata.value.EntityId,
        HospitalId: HospitalId,
        BranchId: BranchId,
        StoreId: 0,
      };
      let result: any = await common.getCodeTemplate(data);
      console.log(result);
      stockreasonform.value.Code = result;
    }

    return {
      model,
      showDialog,
      stockreasonform,
      IsCreate,
      IsEdit,
      IsClear,
      GetCode,
      IsSubmit,
      IsConfirmEdit,
      successpop,
      Editmodel,
      closetrigger,
      updatepop,
      alreadyclosetrigger,
      alreadyexistpop,
      label,
      Saveloading,
    };
  },
});
</script>
